import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-345" data-mp="2wzyrogkxb6jz">
      <div className="mx-auto max-w-4xl" data-id="element-346" data-mp="2szyet0dh33f1">
        <SectionHeading eyebrow="What’s inside" title={<>
              What will you find inside the <em className="text-brand-700" data-id="element-348" data-mp="2o2ogev83vhf2">7D Apometry Protocol™?</em>
            </>} data-id="element-347" data-mp="2syws1yn3gshh" />
        <div className="mt-10 space-y-5" data-id="element-349" data-mp="2j7sd2yxf57mn">
          {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl bg-white ring-1 ring-brand-100" data-id="element-350" data-mp="2ebbmly2qyh6e">
              <div className="flex items-center gap-4 bg-brand-800 px-6 py-4" data-id="element-351" data-mp="29dij5cstw19t">
                <span className="font-display text-4xl font-extrabold text-gold" data-id="element-352" data-mp="258spzvpk10sl">{v.numeral}</span>
                <div data-id="element-353" data-mp="20cbyqsn266ba">
                  <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-brand-200" data-id="element-354" data-mp="20d3x2b81ii59">Volume {v.numeral}</p>
                  <h3 className="font-display text-xl font-bold leading-tight text-white sm:text-2xl" data-id="element-355" data-mp="37wciojvzygf7">{v.title}</h3>
                </div>
              </div>
              <div className="p-6" data-id="element-356" data-mp="2u6966kmx612y">
                <p className="text-[16px] leading-relaxed text-ink-soft" data-id="element-357" data-mp="2u34ruufqpoyk">{v.intro}</p>
                <p className="mt-5 text-xs font-bold uppercase tracking-wider text-brand-700" data-id="element-358" data-mp="2y4gm5d9k6yd3">Includes</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-359" data-mp="3luavvlyl06t4">
                  {v.includes.map(item => <li key={item} className="flex items-start gap-2.5 text-[16px] text-ink" data-id="element-360" data-mp="3cvpevv8rczug">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-361" data-mp="3hua65561896r" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
        <CtaButton label="I want all 6 volumes" className="mt-12" data-id="element-362" data-mp="26dag6g75q6fw" />
      </div>
    </section>;
}